module.exports = __webpack_public_path__ + "static/media/campfire.d778c774.svg";